// PLAN.md §3.4 — 400ms LIQUIDATED splash that fades over 800ms total.

import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { useStore } from '../store.js'

const SPLASH_LIFETIME_MS = 800

export function LiquidatedSplash() {
  const at = useStore((s) => s.selfLiquidatedAt)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (at === null) return
    setVisible(true)
    const id = setTimeout(() => setVisible(false), SPLASH_LIFETIME_MS)
    return () => clearTimeout(id)
  }, [at])

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.06 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="pointer-events-none fixed inset-0 z-[200] flex items-center justify-center"
        >
          <div className="px-12 py-6 rounded-2xl border-2 border-red bg-black/60 backdrop-blur">
            <span className="text-headline tracking-widest text-red font-bold uppercase">
              Liquidated
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
